import type { ReactElement } from 'react';
import Collapse from 'react-bootstrap/Collapse';

import UpcomingMenu from 'models/UpcomingMenu';

import RecipientDetails from './RecipientDetails';
import SummaryDetails from './SummaryDetails';

function Details({ item }: { item: UpcomingMenu }): ReactElement {
  const { areDetailsExpanded } = item;

  return (
    <Collapse in={areDetailsExpanded}>
      <div className="c-order-details">
        <div className="c-order-details__content">
          <div className="row">
            <SummaryDetails item={item} />
            <RecipientDetails item={item} />
          </div>
        </div>
      </div>
    </Collapse>
  );
}

export default Details;
